import { createSelector } from '@ngrx/store'
import { ConnectionState } from './connection.reducer'

export const selectConnectionState = (state): ConnectionState => state.connection

export const isOnline = createSelector(selectConnectionState, connection => connection.isOnline)
